export { default } from './ProfileCard';
